import {
  ADD_PAYMENT_REQUEST_REQUEST,
  ADD_PAYMENT_REQUEST_SUCCESS,
  ADD_PAYMENT_REQUEST_FAILURE,
  ADD_APPROVE_REQUEST_REQUEST,
  ADD_APPROVE_REQUEST_SUCCESS,
  ADD_APPROVE_REQUEST_FAILURE,
  ADD_ATTEST_REQUEST_REQUEST,
  ADD_ATTEST_REQUEST_SUCCESS,
  ADD_ATTEST_REQUEST_FAILURE,
  ADD_VERIFY_REQUEST_REQUEST,
  ADD_VERIFY_REQUEST_SUCCESS,
  ADD_VERIFY_REQUEST_FAILURE,
  ADD_REJECT_REQUEST_REQUEST,
  ADD_REJECT_REQUEST_SUCCESS,
  ADD_REJECT_REQUEST_FAILURE,
  ADD_PAY_REQUEST_REQUEST,
  ADD_PAY_REQUEST_SUCCESS,
  ADD_PAY_REQUEST_FAILURE,
  ADD_QUERY_REQUEST_REQUEST,
  ADD_QUERY_REQUEST_SUCCESS,
  ADD_QUERY_REQUEST_FAILURE,
  ADD_COMMENT_REQUEST_REQUEST,
  ADD_COMMENT_REQUEST_SUCCESS,
  ADD_COMMENT_REQUEST_FAILURE,
  FETCH_PAYMENT_REQUESTS_REQUEST,
  FETCH_PAYMENT_REQUESTS_SUCCESS,
  FETCH_PAYMENT_REQUESTS_FAILURE,
  UPDATE_PAYMENT_REQUEST_REQUEST,
  UPDATE_PAYMENT_REQUEST_SUCCESS,
  UPDATE_PAYMENT_REQUEST_FAILURE,
  DELETE_PAYMENT_REQUEST_REQUEST,
  DELETE_PAYMENT_REQUEST_SUCCESS,
  DELETE_PAYMENT_REQUEST_FAILURE,
  CLEAR_PAYMENT_REQUESTS_ERROR,
  FETCH_PAYMENT_REQUEST_DETAILS_REQUEST,
  FETCH_PAYMENT_REQUEST_DETAILS_SUCCESS,
  FETCH_PAYMENT_REQUEST_DETAILS_FAILURE,
  FETCH_PAYMENT_REQUEST_VOUCHERS_REQUEST,
  FETCH_PAYMENT_REQUEST_VOUCHERS_SUCCESS,
  FETCH_PAYMENT_REQUEST_VOUCHERS_FAILURE,
  SUBMIT_PAYMENT_REQUEST_REQUEST,
  SUBMIT_PAYMENT_REQUEST_SUCCESS,
  SUBMIT_PAYMENT_REQUEST_FAILURE,
  UPLOAD_RECEIPT_REQUEST,
  UPLOAD_RECEIPT_SUCCESS,
  UPLOAD_RECEIPT_FAILURE,
  FETCH_RECEIPT_REQUEST,
  FETCH_RECEIPT_SUCCESS,
  FETCH_RECEIPT_FAILURE,
  FETCH_SUPPORTING_DOCUMENT_REQUEST,
  FETCH_SUPPORTING_DOCUMENT_SUCCESS,
  FETCH_SUPPORTING_DOCUMENT_FAILURE,
} from "./paymentRequestActionTypes";
import api from "../../api/api";
import { toast } from "react-toastify";

const handleError = (error) => {
  const errorDetails = error.response?.data || error.request || error.message;
  console.error("API Error Details:", errorDetails);
  if (error.response) {
    if (error.response.data?.errors) {
      const validationErrors = Object.values(error.response.data.errors)
        .flat()
        .join("; ");
      return (
        validationErrors ||
        error.response.data?.message ||
        `Error ${error.response.status}: ${error.response.statusText}`
      );
    }
    return (
      error.response.data?.message ||
      `Error ${error.response.status}: ${error.response.statusText}`
    );
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

export const addPaymentRequest_1 = (paymentRequestData) => async (dispatch) => {
  dispatch({ type: ADD_PAYMENT_REQUEST_REQUEST });
  try {
    console.log("API - addPaymentRequest payload:", paymentRequestData);
    const response = await api.post("/PaymentVoucher", paymentRequestData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - addPaymentRequest response:", response.data);
    dispatch({ type: ADD_PAYMENT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Payment request added successfully.");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - addPaymentRequest error:", errorMessage);
    dispatch({ type: ADD_PAYMENT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const addPaymentRequest_2 = (paymentRequestData) => async (dispatch) => {
  dispatch({ type: ADD_PAYMENT_REQUEST_REQUEST });
  try {
    const formData = new FormData();
    formData.append("RequestTypeId", paymentRequestData.RequestTypeId);
    formData.append(
      "SupportingDocuments",
      paymentRequestData.SupportingDocuments || "",
    );
    formData.append("UserId", paymentRequestData.UserId);
    formData.append("Currency", paymentRequestData.Currency);
    formData.append("ProjectId", paymentRequestData.ProjectId);
    formData.append("Amount", paymentRequestData.Amount);
    formData.append("PurposeId", paymentRequestData.PurposeId);
    formData.append("Description", paymentRequestData.Description);
    formData.append("IsOnSaved", paymentRequestData.IsOnSaved);

    console.log("API - addPaymentRequest payload:", formData);

    const response = await api.post("/PaymentVoucher", formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
        Accept: "text/plain",
      },
    });

    console.log("API - addPaymentRequest response:", response.data);
    dispatch({ type: ADD_PAYMENT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Payment request added successfully.");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - addPaymentRequest error:", errorMessage);
    dispatch({ type: ADD_PAYMENT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const addPaymentRequest = (paymentRequestData) => async (dispatch) => {
  dispatch({ type: ADD_PAYMENT_REQUEST_REQUEST });
  try {
    console.log("API - addPaymentRequest payload:", paymentRequestData);
    const response = await api.post("/PaymentVoucher", paymentRequestData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
        Accept: "*/*",
      },
    });
    console.log("API - addPaymentRequest response:", response.data);
    dispatch({ type: ADD_PAYMENT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Payment request added successfully.");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - addPaymentRequest error:", errorMessage);
    dispatch({ type: ADD_PAYMENT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

// export const approvePaymentRequest = (requestId) => async (dispatch) => {
//   dispatch({ type: ADD_APPROVE_REQUEST_REQUEST });
//   try {
//     console.log("API - approvePaymentRequest requestId:", requestId);
//     const response = await api.post(
//       `/PaymentVoucher/approve/${requestId}`,
//       {},
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "application/json-patch+json",
//           Accept: "*/*",
//         },
//       },
//     );
//     console.log("API - approvePaymentRequest response:", response.data);
//     dispatch({ type: ADD_APPROVE_REQUEST_SUCCESS, payload: response.data });
//     toast.success("Payment request approved successfully.");
//   } catch (error) {
//     const errorMessage = handleError(error);
//     console.error("API - approvePaymentRequest error:", errorMessage);
//     dispatch({ type: ADD_APPROVE_REQUEST_FAILURE, payload: errorMessage });
//     toast.error(errorMessage);
//     throw error;
//   }
// };

export const approvePaymentRequest =
  (requestId, userId) => async (dispatch) => {
    dispatch({ type: ADD_APPROVE_REQUEST_REQUEST });
    try {
      console.log(
        "API - approvePaymentRequest requestId:",
        requestId,
        "userId:",
        userId,
      );
      const response = await api.post(
        `/PaymentVoucher/approve/${requestId}?userId=${userId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json-patch+json",
            Accept: "*/*",
          },
        },
      );
      console.log("API - approvePaymentRequest response:", response.data);
      dispatch({ type: ADD_APPROVE_REQUEST_SUCCESS, payload: response.data });
      toast.success("Payment request approved successfully.");
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - approvePaymentRequest error:", errorMessage);
      dispatch({ type: ADD_APPROVE_REQUEST_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      throw error;
    }
  };

export const attestPaymentRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_ATTEST_REQUEST_REQUEST });
  try {
    console.log("API - attestPaymentRequest requestId:", requestId);
    const response = await api.post(
      `/PaymentVoucher/attest/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - attestPaymentRequest response:", response.data);
    dispatch({ type: ADD_ATTEST_REQUEST_SUCCESS, payload: response.data });
    toast.success("Payment request attested successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - attestPaymentRequest error:", errorMessage);
    dispatch({ type: ADD_ATTEST_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const verifyPaymentRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_VERIFY_REQUEST_REQUEST });
  try {
    console.log("API - verifyPaymentRequest requestId:", requestId);
    const response = await api.post(
      `/PaymentVoucher/verify/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - verifyPaymentRequest response:", response.data);
    dispatch({ type: ADD_VERIFY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Payment request verified successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - verifyPaymentRequest error:", errorMessage);
    dispatch({ type: ADD_VERIFY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const rejectPaymentRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_REJECT_REQUEST_REQUEST });
  try {
    console.log("API - rejectPaymentRequest requestId:", requestId);
    const response = await api.post(
      `/PaymentVoucher/reject/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - rejectPaymentRequest response:", response.data);
    dispatch({ type: ADD_REJECT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Payment request rejected successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - rejectPaymentRequest error:", errorMessage);
    dispatch({ type: ADD_REJECT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

// export const payPaymentRequest =
//   (requestId, paymentCode, requiresReceipt) => async (dispatch) => {
//     dispatch({ type: ADD_PAY_REQUEST_REQUEST });
//     try {
//       console.log("API - payPaymentRequest payload:", {
//         requestId,
//         paymentCode,
//         requiresReceipt,
//       });
//       const response = await api.post(
//         `/PaymentVoucher/pay`,
//         {
//           requestId,
//           paymentCode,
//           requiresReceipt,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json-patch+json",
//             Accept: "*/*",
//           },
//         },
//       );
//       console.log("API - payPaymentRequest response:", response.data);
//       dispatch({ type: ADD_PAY_REQUEST_SUCCESS, payload: response.data });
//       toast.success("Payment processed successfully.");
//     } catch (error) {
//       const errorMessage = handleError(error);
//       console.error("API - payPaymentRequest error:", errorMessage);
//       dispatch({ type: ADD_PAY_REQUEST_FAILURE, payload: errorMessage });
//       toast.error(errorMessage);
//       throw error;
//     }
//   };
//

// export const payPaymentRequest =
//   (requestId, paymentCode, requiresReceipt, vendorName, userId) =>
//   async (dispatch) => {
//     dispatch({ type: ADD_PAY_REQUEST_REQUEST });
//     try {
//       console.log("API - payPaymentRequest payload:", {
//         requestId,
//         paymentCode,
//         requiresReceipt,
//         vendorName,
//         userId,
//       });
//       const response = await api.post(
//         `/PaymentVoucher/pay?userId=${userId}`,
//         {
//           requestId,
//           paymentCode,
//           requiresReceipt,
//           vendorName,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json-patch+json",
//             Accept: "*/*",
//           },
//         },
//       );
//       console.log("API - payPaymentRequest response:", response.data);
//       dispatch({ type: ADD_PAY_REQUEST_SUCCESS, payload: response.data });
//       toast.success("Payment processed successfully.");
//     } catch (error) {
//       const errorMessage = handleError(error);
//       console.error("API - payPaymentRequest error:", errorMessage);
//       dispatch({ type: ADD_PAY_REQUEST_FAILURE, payload: errorMessage });
//       toast.error(errorMessage);
//       throw error;
//     }
//   };

export const payPaymentRequest =
  (
    requestId,
    paymentCode,
    requiresReceipt,
    vendorName,
    userId,
    paymentMethod,
    checkNumber,
    checkDate,
    bank,
    amount,
    currency,
    payTo,
    approvedBy,
    entityType,
  ) =>
  async (dispatch) => {
    dispatch({ type: ADD_PAY_REQUEST_REQUEST });
    try {
      console.log("API - payPaymentRequest payload:", {
        requestId,
        paymentCode,
        requiresReceipt,
        vendorName,
        userId,
        paymentMethod,
        checkNumber,
        checkDate,
        bank,
        amount,
        currency,
        payTo,
        approvedBy,
        entityType,
      });

      let response;
      if (paymentMethod === "Check") {
        // Check payment endpoint
        response = await api.post(
          `/RequestSetting/makechequepayment?userId=${userId}`,
          {
            requestId,
            paymentCode,
            requiresReceipt,
            vendorName: requiresReceipt ? vendorName : undefined,
            entityType,
            chequeNumber: checkNumber,
            bankName: bank,
            chequeIssueDate: checkDate,
            amount,
            currency,
            payTo,
            approveBy: approvedBy,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json-patch+json",
              Accept: "*/*",
            },
          },
        );
      } else {
        // Cash payment endpoint
        response = await api.post(
          `/PaymentVoucher/pay?userId=${userId}`,
          {
            requestId,
            paymentCode,
            requiresReceipt,
            vendorName: requiresReceipt ? vendorName : undefined,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json-patch+json",
              Accept: "*/*",
            },
          },
        );
      }

      console.log("API - payPaymentRequest response:", response.data);
      dispatch({ type: ADD_PAY_REQUEST_SUCCESS, payload: response.data });
      toast.success("Payment processed successfully.");
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - payPaymentRequest error:", errorMessage);
      dispatch({ type: ADD_PAY_REQUEST_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      throw error;
    }
  };

export const queryPaymentRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_QUERY_REQUEST_REQUEST });
  try {
    console.log("API - queryPaymentRequest requestId:", requestId);
    const response = await api.post(
      `/PaymentVoucher/query/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - queryPaymentRequest response:", response.data);
    dispatch({ type: ADD_QUERY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Query submitted successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - queryPaymentRequest error:", errorMessage);
    dispatch({ type: ADD_QUERY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const queryPaymentRequestComment = (payload) => async (dispatch) => {
  dispatch({ type: ADD_QUERY_REQUEST_REQUEST });
  try {
    console.log("API - queryPaymentRequestComment payload:", payload);
    const response = await api.post(`/PaymentVoucher/query`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - queryPaymentRequestComment response:", response.data);
    dispatch({ type: ADD_QUERY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Query comment submitted successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - queryPaymentRequestComment error:", errorMessage);
    dispatch({ type: ADD_QUERY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const commentPaymentRequestReject = (payload) => async (dispatch) => {
  dispatch({ type: ADD_COMMENT_REQUEST_REQUEST });
  try {
    console.log("API - commentPaymentRequestReject payload:", payload);
    const response = await api.post(`/PaymentVoucher/reject`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - commentPaymentRequestReject response:", response.data);
    dispatch({ type: ADD_COMMENT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Request comment submitted successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - commentPaymentRequestReject error:", errorMessage);
    dispatch({ type: ADD_COMMENT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchPaymentRequests = () => async (dispatch) => {
  dispatch({ type: FETCH_PAYMENT_REQUESTS_REQUEST });
  try {
    console.log("API - fetchPaymentRequests");
    const response = await api.get("/PaymentVoucher", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - fetchPaymentRequests response:", response.data);
    dispatch({ type: FETCH_PAYMENT_REQUESTS_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - fetchPaymentRequests error:", errorMessage);
    dispatch({ type: FETCH_PAYMENT_REQUESTS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchPaymentRequestDetails =
  (requestId, paymentCode) => async (dispatch) => {
    dispatch({ type: FETCH_PAYMENT_REQUEST_DETAILS_REQUEST });
    try {
      if (!requestId || isNaN(requestId)) {
        throw new Error("Invalid requestId");
      }
      const cleanRequestId = String(requestId).trim();
      console.log(
        "API - fetchPaymentRequestDetails requestId:",
        cleanRequestId,
      );
      const response = await api.get(`/PaymentVoucher/${cleanRequestId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      });
      console.log(
        "API - fetchPaymentRequestDetails response:",
        response.data.paymentCode,
        response.data,
      );
      dispatch({
        type: FETCH_PAYMENT_REQUEST_DETAILS_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - fetchPaymentRequestDetails error:", errorMessage);
      dispatch({
        type: FETCH_PAYMENT_REQUEST_DETAILS_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw error;
    }
  };

export const fetchPaymentRequestVouchers =
  (voucherId, paymentCode, documentType) => async (dispatch) => {
    dispatch({ type: FETCH_PAYMENT_REQUEST_VOUCHERS_REQUEST });
    try {
      if (!voucherId || isNaN(voucherId)) {
        throw new Error("Invalid voucherId");
      }
      if (
        !documentType ||
        typeof documentType !== "string" ||
        documentType.trim() === ""
      ) {
        throw new Error("Invalid or missing documentType");
      }
      const cleanDocumentType = documentType.trim();
      const cleanVoucherId = String(voucherId).trim();
      const url = `/PaymentVoucher/view-voucher/${cleanVoucherId}?documentType=${decodeURIComponent(
        cleanDocumentType,
      )}`;
      console.log("API - fetchPaymentRequestVouchers URL:", url);
      const response = await api.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      });
      console.log("API - fetchPaymentRequestVouchers response:", {
        status: response.status,
        headers: response.headers,
        dataType: response.data.type,
        dataSize: response.data.size,
      });

      if (!response.data || response.data.size === 0) {
        throw new Error("No PDF data received from the server");
      }
      if (response.data.type !== "application/pdf") {
        throw new Error(
          `Invalid response type: expected application/pdf, got ${response.data.type}`,
        );
      }

      const pdfUrl = URL.createObjectURL(response.data);
      const filename =
        response.headers["content-disposition"]?.match(
          /filename=(?:"([^"]+)"|(\S+))/,
        )?.[1] || `PettyCash_${paymentCode}.pdf`;
      const payload = { url: pdfUrl, filename };

      dispatch({ type: FETCH_PAYMENT_REQUEST_VOUCHERS_SUCCESS, payload });
      return payload;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - fetchPaymentRequestVouchers error:", errorMessage);
      if (error.response?.status === 404) {
        console.warn(
          "API - fetchPaymentRequestVouchers: Voucher not found, returning empty payload",
        );
        const payload = { url: null, filename: null };
        dispatch({ type: FETCH_PAYMENT_REQUEST_VOUCHERS_SUCCESS, payload });
        return payload;
      }
      dispatch({
        type: FETCH_PAYMENT_REQUEST_VOUCHERS_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw error;
    }
  };

export const fetchSupportingDocument = (requestId) => async (dispatch) => {
  dispatch({ type: FETCH_SUPPORTING_DOCUMENT_REQUEST });
  try {
    if (!requestId || isNaN(requestId)) {
      throw new Error("Invalid requestId");
    }
    const cleanRequestId = String(requestId).trim();
    const url = `/PaymentVoucher/supporting-document/${cleanRequestId}`;
    console.log("API - fetchSupportingDocument URL:", url);
    const response = await api.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - fetchSupportingDocument response:", {
      status: response.status,
      headers: response.headers,
      dataType: response.data.type,
      dataSize: response.data.size,
    });

    if (!response.data || response.data.size === 0) {
      throw new Error("No supporting document data received from the server");
    }

    const contentType = response.data.type;
    let isImage = contentType.startsWith("image/");
    let isPdf = contentType === "application/pdf";
    let isWord =
      contentType === "application/msword" ||
      contentType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    let isExcel =
      contentType === "application/vnd.ms-excel" ||
      contentType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    let inferredType = contentType;
    let filename = null;
    let extension = "";

    if (contentType === "application/octet-stream") {
      const disposition = response.headers["content-disposition"];
      console.log(
        "API - fetchSupportingDocument content-disposition:",
        disposition,
      );
      if (disposition) {
        const filenameStarMatch = disposition.match(
          /filename\*=UTF-8''(.+?)(?:;|$)/,
        );
        if (filenameStarMatch) {
          filename = decodeURIComponent(filenameStarMatch[1].trim());
        } else {
          const filenameMatch = disposition.match(
            /filename=["']?([^;"']+)["']?/i,
          );
          filename = filenameMatch ? filenameMatch[1] : null;
        }
      }
      filename = filename || `SupportingDocument_${cleanRequestId}`;
      console.log("API - fetchSupportingDocument inferred filename:", filename);

      const extensionMatch = filename.match(/\.([a-zA-Z0-9]+)$/i);
      extension = extensionMatch ? extensionMatch[1].toLowerCase() : "pdf";
      console.log("API - fetchSupportingDocument extension:", extension);

      if (extension === "pdf") {
        isPdf = true;
        inferredType = "application/pdf";
      } else if (["png", "jpg", "jpeg", "gif"].includes(extension)) {
        isImage = true;
        inferredType = `image/${extension}`;
      } else if (["doc", "docx"].includes(extension)) {
        isWord = true;
        inferredType =
          extension === "doc"
            ? "application/msword"
            : "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (["xls", "xlsx"].includes(extension)) {
        isExcel = true;
        inferredType =
          extension === "xls"
            ? "application/vnd.ms-excel"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else {
        console.warn(
          `Cannot infer file type for application/octet-stream with filename: ${filename}. Assuming application/pdf.`,
        );
        isPdf = true;
        inferredType = "application/pdf";
        extension = "pdf";
      }
    } else {
      if (isPdf) {
        extension = "pdf";
      } else if (isImage) {
        extension = contentType.split("/")[1].toLowerCase();
      } else if (isWord) {
        extension = contentType.includes("openxml") ? "docx" : "doc";
      } else if (isExcel) {
        extension = contentType.includes("openxml") ? "xlsx" : "xls";
      }
      filename = `SupportingDocument_${cleanRequestId}`;
      console.log(
        "API - fetchSupportingDocument non-octet filename:",
        filename,
        "extension:",
        extension,
      );
    }

    const documentUrl = URL.createObjectURL(response.data);
    const filenameFinal = `SupportingDocument_${cleanRequestId}.${extension || "pdf"}`;
    console.log("API - fetchSupportingDocument filenameFinal:", filenameFinal);

    const payload = {
      url: documentUrl,
      filename: filenameFinal,
      contentType: inferredType,
    };

    console.log("API - fetchSupportingDocument dispatched payload:", payload);
    dispatch({ type: FETCH_SUPPORTING_DOCUMENT_SUCCESS, payload });
    return payload;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - fetchSupportingDocument error:", errorMessage);
    if (error.response?.status === 404) {
      console.warn(
        "API - fetchSupportingDocument: Document not found, returning empty payload",
      );
      const payload = { url: null, filename: null, contentType: null };
      dispatch({ type: FETCH_SUPPORTING_DOCUMENT_SUCCESS, payload });
      return payload;
    }
    dispatch({
      type: FETCH_SUPPORTING_DOCUMENT_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const uploadReceipt = (requestId, userId, files) => async (dispatch) => {
  dispatch({ type: UPLOAD_RECEIPT_REQUEST });
  try {
    if (!files || !Array.isArray(files) || files.length === 0) {
      throw new Error("No files provided for upload");
    }
    if (files.length > 1) {
      throw new Error("Only one file can be uploaded at a time");
    }
    const file = files[0];
    const formData = new FormData();
    formData.append("Files", file);
    formData.append("RequestId", requestId);
    formData.append("UserId", userId);

    for (let [key, value] of formData.entries()) {
      console.log(`API - uploadReceipt FormData: ${key}=${value}`);
    }
    console.log(
      "API - uploadReceipt URL: /api/documents/upload",
      "RequestId:",
      requestId,
      "UserId:",
      userId,
      "File:",
      file.name,
      file.type,
      file.size,
    );

    const response = await api.post("/api/documents/upload", formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
        Accept: "*/*",
      },
    });

    console.log("API - uploadReceipt response:", response.data);

    if (!response.data) {
      throw new Error("Invalid API response: response.data is empty");
    }

    const data = Array.isArray(response.data)
      ? response.data[0]
      : response.data;
    if (!data || typeof data !== "object") {
      throw new Error("Invalid API response: expected an object");
    }

    const { id, receiptFilePath, uploadedOn } = data;
    if (!id || !receiptFilePath || !uploadedOn) {
      console.error("API - uploadReceipt missing fields:", {
        id,
        receiptFilePath,
        uploadedOn,
      });
      throw new Error(
        "API response missing required fields (id, receiptFilePath, uploadedOn)",
      );
    }

    const payload = {
      id,
      url: receiptFilePath,
      uploadedOn,
      name: receiptFilePath.split("/").pop() || file.name,
    };

    dispatch({ type: UPLOAD_RECEIPT_SUCCESS, payload });
    toast.success("Receipt uploaded successfully.");
    return payload;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error(
      "API - uploadReceipt full error:",
      errorMessage,
      error.response?.data,
      error.response?.status,
      error.response?.headers,
      error.response?.config?.url,
    );
    dispatch({ type: UPLOAD_RECEIPT_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchReceipt = (requestId) => async (dispatch) => {
  dispatch({ type: FETCH_RECEIPT_REQUEST });
  try {
    if (!requestId || isNaN(requestId)) {
      throw new Error("Invalid requestId");
    }
    const cleanRequestId = String(requestId).trim();
    const url = `/api/Documents/view-receipt/${cleanRequestId}`;
    console.log("API - fetchReceipt URL:", url);
    const response = await api.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - fetchReceipt response:", {
      status: response.status,
      headers: response.headers,
      dataType: response.data.type,
      dataSize: response.data.size,
    });

    if (!response.data || response.data.size === 0) {
      throw new Error("No receipt data received from the server");
    }

    const contentType = response.data.type;
    let isImage = contentType.startsWith("image/");
    let isPdf = contentType === "application/pdf";
    let inferredType = contentType;
    let filename = null;
    let extension = "";

    if (contentType === "application/octet-stream") {
      const disposition = response.headers["content-disposition"];
      console.log("API - fetchReceipt content-disposition:", disposition);
      if (disposition) {
        const filenameStarMatch = disposition.match(
          /filename\*=UTF-8''(.+?)(?:;|$)/,
        );
        if (filenameStarMatch) {
          filename = decodeURIComponent(filenameStarMatch[1].trim());
          console.log("API - fetchReceipt filename* match:", filename);
        } else {
          const filenameMatch = disposition.match(
            /filename=["']?([^;"']+)["']?/i,
          );
          filename = filenameMatch ? filenameMatch[1] : null;
          console.log("API - fetchReceipt filename match:", filename);
        }
      }
      filename = filename || `Receipt_${cleanRequestId}`;
      console.log("API - fetchReceipt inferred filename:", filename);

      const extensionMatch = filename.match(/\.([a-zA-Z0-9]+)$/i);
      extension = extensionMatch ? extensionMatch[1].toLowerCase() : "png";
      console.log("API - fetchReceipt extension:", extension);

      if (extension === "pdf") {
        isPdf = true;
        inferredType = "application/pdf";
      } else if (["png", "jpg", "jpeg", "gif"].includes(extension)) {
        isImage = true;
        inferredType = `image/${extension}`;
      } else {
        console.warn(
          `Cannot infer file type for application/octet-stream with filename: ${filename}. Assuming image/png.`,
        );
        isImage = true;
        inferredType = "image/png";
        extension = "png";
      }
    } else {
      if (isPdf) {
        extension = "pdf";
      } else if (isImage) {
        extension = contentType.split("/")[1].toLowerCase();
      }
      filename = `Receipt_${cleanRequestId}`;
      console.log(
        "API - fetchReceipt non-octet filename:",
        filename,
        "extension:",
        extension,
      );
    }

    const receiptUrl = URL.createObjectURL(response.data);
    const filenameFinal = `Receipt_${cleanRequestId}.${isPdf ? "pdf" : extension || "png"}`;
    console.log("API - fetchReceipt filenameFinal:", filenameFinal);

    const payload = {
      url: receiptUrl,
      filename: filenameFinal,
      contentType: inferredType,
    };

    console.log("API - fetchReceipt dispatched payload:", payload);
    dispatch({ type: FETCH_RECEIPT_SUCCESS, payload });
    return payload;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - fetchReceipt error:", errorMessage);
    if (error.response?.status === 404) {
      console.warn(
        "API - fetchReceipt: Receipt not found, returning empty payload",
      );
      const payload = { url: null, filename: null, contentType: null };
      dispatch({ type: FETCH_RECEIPT_SUCCESS, payload });
      return payload;
    }
    dispatch({ type: FETCH_RECEIPT_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const updatePaymentRequest =
  (requestId, paymentRequestData) => async (dispatch) => {
    dispatch({ type: UPDATE_PAYMENT_REQUEST_REQUEST });
    try {
      console.log("API - updatePaymentRequest payload:", paymentRequestData);
      const response = await api.put(
        `/PaymentVoucher/${requestId}`,
        paymentRequestData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json-patch+json",
            Accept: "*/*",
          },
        },
      );
      console.log("API - updatePaymentRequest response:", response.data);
      dispatch({
        type: UPDATE_PAYMENT_REQUEST_SUCCESS,
        payload: response.data,
      });
      toast.success("Payment request updated successfully.");
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - updatePaymentRequest error:", errorMessage);
      dispatch({ type: UPDATE_PAYMENT_REQUEST_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      throw error;
    }
  };

export const deletePaymentRequest = (requestId) => async (dispatch) => {
  dispatch({ type: DELETE_PAYMENT_REQUEST_REQUEST });
  try {
    console.log("API - deletePaymentRequest requestId:", requestId);
    await api.delete(`/PaymentVoucher/${requestId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - deletePaymentRequest success:", requestId);
    dispatch({ type: DELETE_PAYMENT_REQUEST_SUCCESS, payload: requestId });
    toast.success("Payment request deleted successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - deletePaymentRequest error:", errorMessage);
    dispatch({ type: DELETE_PAYMENT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const submitPaymentRequest = (requestId) => async (dispatch) => {
  dispatch({ type: SUBMIT_PAYMENT_REQUEST_REQUEST });
  try {
    console.log("API - submitPaymentRequest requestId:", requestId);
    const response = await api.post(
      `/PaymentVoucher/submit/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - submitPaymentRequest response:", response.data);
    dispatch({ type: SUBMIT_PAYMENT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Payment request submitted successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - submitPaymentRequest error:", errorMessage);
    dispatch({ type: SUBMIT_PAYMENT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const clearPaymentRequestsError = () => ({
  type: CLEAR_PAYMENT_REQUESTS_ERROR,
});
